export function resetRowSelect() {
    return {
        type: "PODCAMP_SETTINGS_RESET_SELECT_ROW"
    }
}